import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { CircularProgress, Stack } from "@mui/material";

import CustomRadioButton from "../../Components/Form Fields/radio-button.js";

import renderRentPaymentDetails from "../../Organisms/Modals/Pay Rent/rent-payment-details.js";

import { useModalContext } from "../../Contexts/ModalContext.js";

import { useRentPayments } from "../../CustomHooks/Queries/index.js";

import { formatCurrency, formatDate } from "../../Utils/helpers.js";
import { longMonthDateFormat } from "../../Utils/constants.js";

import { ArrowLeftCircle, DocumentHistory, Funnel } from "../../Assets/Icons/index.js";

const filterOptions = {
  Upcoming: "Upcoming",
  Success: "Success",
  Pending: "Pending",
  Canceled: "Canceled",
  "In-Progress": "InProgress",
  Failed: "Failed",
  Rejected: "Rejected",
};

export default function RentPaymentActivity({ presentedForSelection = false, preferredPayee, onChange }) {
  const [filterStatus, setFilterStatus] = useState(null);

  const navigate = useNavigate();

  const modalContext = useModalContext();

  const { isLoading: isLoadingRentPayments, data: rentPayments } = useRentPayments({ status: filterStatus });

  return (
    <div className="rent-payment-activity">
      <section className="card-section-wrapper">
        <div className="max-width-container">
          <div className="card-section">
            {!presentedForSelection && (
              <div className="section-header">
                <button className="go-back-button" onClick={() => navigate(-1)} aria-label="Go back">
                  <ArrowLeftCircle />
                </button>
                <h3 className="section-title">Rent Payment Activity</h3>
                <Dropdown className="custom-menu no-max-height" align="end">
                  <Dropdown.Toggle className="no-style" as="button" type="button">
                    <Funnel />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" padding="8px 16px">
                      <span className="text-xs-regular color--american-silver">Filter Status</span>
                      <button className="text-xs-regular color--primary-400" onClick={setFilterStatus.bind(this, null)}>
                        Reset
                      </button>
                    </Stack>
                    {Object.entries(filterOptions).map(([key, value], idx) => (
                      <Stack key={idx} direction="row" alignItems="center" padding="8px 16px" gap="12px">
                        <CustomRadioButton
                          id={`rpa-filter-${idx}`}
                          name="rpa-filter-status"
                          checked={filterStatus === value}
                          value={value}
                          onChange={(e) => setFilterStatus(e.target.value)}
                          aria-label={key}
                        />
                        <label htmlFor={`rpa-filter-${idx}`} className="text-base-medium color--mist">{key}</label>
                      </Stack>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
            {isLoadingRentPayments ? (
              <div className="loading-content">
                <CircularProgress />
              </div>
            ) : rentPayments?.length > 0 ? (
              <div className="content mt-3">
                <div className="top-container">
                  {rentPayments?.map((transaction, idx) => (
                    <button
                      key={idx}
                      className="rent-transaction-activity"
                      onClick={renderRentPaymentDetails.bind(this, modalContext, { paymentDetails: transaction })}
                    >
                      <div className="transfer-detail py-0">
                        <span className="transfer-date">
                          {formatDate(transaction?.created_at, longMonthDateFormat)}
                        </span>
                        <span className="transfer-value">{formatCurrency(transaction?.total)}</span>
                      </div>
                      <div className="transfer-detail py-0">
                        <span className="transaction-description">
                          {transaction?.type} payment to {transaction?.payee}
                        </span>
                        <div className={`transfer-status-badge ${transaction.statusType}`}>
                          <transaction.StatusIcon /> {transaction?.statusDisplayName}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            ) : (
              <div className="no-records">
                <DocumentHistory className="icon" />
                No payment history found{`${!!filterStatus ? " for the applied filter" : ""}`}.
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
